import { UserRole } from './users-api.service';

export enum Action {
    retryEvents = 'retryEvents',
    editProducts = 'editProducts',
}

// There permissions are in addition to permissions defined in the NavBar
const actionPermissions: { [key in Action]: UserRole[] } = {
    [Action.retryEvents]: ['admin', 'developer', 'finance'],
    [Action.editProducts]: ['admin', 'finance'],
};

export function canPerformAction(role: string | null, action: Action): boolean {
    if (!role) return false;
    const allowedRoles = actionPermissions[action];
    return allowedRoles.includes(role as UserRole);
}
